module.exports = __webpack_public_path__ + "img/user-threat-guide.6df938a3.png";